import React from "react";
import BreadCrumbsContainer from "./containers/BreadCrumbsContainer";
import HomeHeaderContainer from "./containers/HomeHeaderContainer";
import { HomeFacadeProvider } from "./facades/Home.facade";
import "./Home.scss";
import { HomeRoutes } from "./HomeRoutes";
import { HomeRepositoryProvider } from "./repository/Home.repository";
import { HomeServiceProvider } from "./services/Home.service";

export const Home = () => {
  return (
    <HomeRepositoryProvider>
      <HomeServiceProvider>
        <HomeFacadeProvider>
          <div className="bg-white">
            <div className="sticky top-0 z-10 w-full">
              <HomeHeaderContainer></HomeHeaderContainer>
            </div>
            <div className="w-full px-6 overflow-y-auto height-excluding-header">
              <div className="px-2 py-2">
                <BreadCrumbsContainer></BreadCrumbsContainer>
              </div>
              <div>
                <HomeRoutes></HomeRoutes>
              </div>
            </div>
          </div>
        </HomeFacadeProvider>
      </HomeServiceProvider>
    </HomeRepositoryProvider>
  );
};
